"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functional_1 = require("./functional");
const generateQueries = (models = [], name) => models.reduce((acc, model, index) => [
    ...acc,
    ...functional_1.pipe.objToArr(model)((0, functional_1.reduce)((acc2, [k, v]) => v.name === name ? [...acc2, { index, id: k }] : acc2, [])),
], []);
exports.default = generateQueries;
//# sourceMappingURL=generate-queries.js.map